export function percentage(part: number): string {
    return (100.0 * part) + "%";
}
